<template>
  <v-container fluid tag="section">
    <v-row>
      <v-col cols="12">
        <base-material-card color="secondary" icon="mdi-trophy-outline" :title="$t('list_match')">
          <v-layout justify-center style="flex-wrap: wrap">
            <v-radio-group row justify-center v-model="filter" @change="loadTable()">
              <v-radio :label="$t('active_f_p')" value="active"></v-radio>
              <v-radio :label="$t('all_f_p')" value="all"></v-radio>
            </v-radio-group>
            <v-btn small class="mx-2 my-2" @click="createGara" v-if="RBAC_EDIT_GARE" color="primary">{{
              $t("create_match")
            }}</v-btn>
            <v-btn small class="mx-2 my-2" @click="manageSchede" v-if="RBAC_EDIT_GARE" color="primary">{{
              $t("manage_evaluation_tables")
            }}</v-btn>
          </v-layout>
          <DataTables @riepilogoGara="riepilogoGara" @editGaraDettaglio="editGaraDettaglio"
            @uploadFotoGara="uploadFotoGara" @printPunteggiDetail="printPunteggiDetail" @printDiplomi="printDiplomi"
            @exportGaraCsv="exportGaraCsv" @importGaraCsv="importGaraCsv" @printPunteggiRecap="printPunteggiRecap"
            @editGara="editGara" @printFoglioGara="printFoglioGara" @viewPunteggiFullscreen="viewPunteggiFullscreen"
            :headers="headers" :tableData="tableData"></DataTables>
        </base-material-card>
      </v-col>
    </v-row>
    <edit-schede ref="editSchedeDialog"></edit-schede>
    <gest-gara @isUpdated="loadTable" ref="gestGaraDialog"></gest-gara>
    <upload-gara @isUpdated="loadTable" ref="uploadGaraDialog"></upload-gara>
    <upload-foto-gara @isUpdated="loadTable" ref="uploadFotoGaraDialog"></upload-foto-gara>
  </v-container>
</template>

<script>
import DataTables from "@/components/base/DataTables.vue";
import editSchede from "@/app/eventi/editSchede.vue";
import gestGara from "@/app/eventi/gestGara.vue";
import uploadGara from "@/app/eventi/uploadGara.vue";
import uploadFotoGara from "@/app/eventi/uploadFotoGara.vue";

import Swal from "sweetalert2";

export default {
  name: "list-gare",
  components: {
    DataTables,
    editSchede,
    gestGara,
    uploadGara,
    uploadFotoGara,
  },
  data() {
    return {
      RBAC_EDIT_GARE: false,
      filter: "active",
      headers: [
        { text: this.$t("image"), value: "image", type: "image" },
        { text: this.$t("title"), value: "titolo" },
        { text: this.$t("active_f_s"), value: "iconActive", type: "icons" },
        { text: this.$t("date_inz"), value: "dateInz", type: "date" },
        { text: this.$t("date_end"), value: "dateEnd", type: "date" },
        { text: this.$t("location"), value: "locationName" },
        { text: this.$t("options"), value: "options", type: "buttons" },
      ],
      tableData: [],
    };
  },

  methods: {
    manageSchede() {
      this.$refs.editSchedeDialog.open();
    },
    printPunteggiRecap(item) {
      let url = "/auth/eventi/pdf/reportGara/" + item.idGara + "?mode=simple";
      window.open(this.authorizeLink(url));
    },
    printPunteggiDetail(item) {
      let url = "/auth/eventi/pdf/reportGara/" + item.idGara + "?mode=full";
      window.open(this.authorizeLink(url));
    },
    printDiplomi(item) {
      let url = "/auth/eventi/pdf/diplomiGara/" + item.idGara;
      window.open(this.authorizeLink(url));
    },
    printFoglioGara(item) {
      let url = "/auth/eventi/pdf/foglioGara/" + item.idGara;
      window.open(this.authorizeLink(url));
    },
    exportGaraCsv(item) {
      let url = "/auth/eventi/csv/exportGaraCsv/" + item.idGara;
      window.open(this.authorizeLink(url));
    },
    importGaraCsv(item) {
      this.$refs.uploadGaraDialog.open(item.idGara);
    },
    uploadFotoGara(item) {
      this.$refs.uploadFotoGaraDialog.open(item.idGara);
    },
    viewPunteggiFullscreen(item) {
      let url = "/publicDashboard/dashboardGara/" + item.idGara;
      let route = this.$router.resolve({ path: url });
      window.open(route.href, "_blank");
    },
    createGara() {
      this.$refs.gestGaraDialog.open("ADD", null);
    },
    editGara(item) {
      this.$refs.gestGaraDialog.open("EDIT", item.idGara);
    },
    riepilogoGara(item) {
      this.$router.push("/portal/eventi/riepilogoGara/" + item.idGara);
    },
    editGaraDettaglio(item) {
      this.$router.push("/portal/eventi/editGaraDettaglio/" + item.idGara);
    },

    loadTable() {
      let _ = this;
      let now = new Date();
      let url = "/auth/eventi/listGare";
      if (_.filter === "all") url += "/all";
      _.tableData = [];
      _.isFetching = true;
      this.chiamataAxios("GET", url).then(response => {
        // Aggiunge actions e icona validazione
        _.tableData = response.data.map(function (item) {
          if (item.attiva === 1) {
            if (new Date(item.dateInz) <= now && new Date(item.dateEnd) >= now)
              item.iconActive = [{ icon: "mdi-check-outline", color: "green" }];
            else
              item.iconActive = [{ icon: "mdi-remove-outline", color: "red" }];
          }

          item.options = [];
          item.options.push({
            icon: "mdi-vote",
            color: "primary",
            text: _.$t("vote"),
            function: "riepilogoGara",
          });
          if (_.RBAC_EDIT_GARE) {
            item.options.push({
              icon: "mdi-pencil",
              color: "secondary",
              text: _.$t("edit_match"),
              function: "editGara",
            });
            item.options.push({
              icon: "mdi-note-text-outline",
              color: "secondary",
              text: _.$t("manage_category"),
              function: "editGaraDettaglio",
            });
            item.options.push({
              icon: "mdi-import",
              color: "error",
              text: _.$t("import_match_from_csv"),
              function: "importGaraCsv",
            });
            item.options.push({
              icon: "mdi-camera",
              color: "error",
              text: _.$t("upload_match_participants_photo"),
              function: "uploadFotoGara",
            });
            item.options.push({
              icon: "mdi-export",
              color: "secondary",
              text: _.$t("extract_csv"),
              function: "exportGaraCsv",
            });
          }
          item.options.push({
            icon: "mdi-cast",
            color: "primary",
            text: _.$t("dashboard"),
            function: "viewPunteggiFullscreen",
          });
          item.options.push({
            icon: "mdi-printer",
            color: "primary",
            text: _.$t("print_match_sheet"),
            function: "printFoglioGara",
          });

          if (item.commissario || item.ifViewVote) {
            item.options.push({
              icon: "mdi-file-document",
              color: "primary",
              text: _.$t("print_recap_match_score"),
              function: "printPunteggiRecap",
            });
            item.options.push({
              icon: "mdi-file-pdf-box",
              color: "red",
              text: _.$t("print_detail_match_score"),
              function: "printPunteggiDetail",
            });
            item.options.push({
              icon: "mdi-certificate",
              color: "primary",
              text: _.$t("print_diplomi"),
              function: "printDiplomi",
            });
          }

          return item;
        });
        _.isFetching = false;
      });
    },
  },
  mounted() {
    this.RBAC_EDIT_GARE = this.checkUserRole("eventi", "EDIT_GARE");
    this.loadTable();
  },
};
</script>